import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AppConfigService } from '../../app/services/app-config.service';
import { UserState } from '../../statemanagement/user.state';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { take } from 'rxjs/operators';

@Directive({
    selector: '[checkViewAsOciUser]',
    standalone: true
})
export class CheckViewAsOciUserDirective {
    @Input() set checkViewAsOciUser(show: boolean) {
        this.showOrHide(show);
    }

    constructor(private appConfigService: AppConfigService,
                private templateRef: TemplateRef<any>,
                private viewContainer: ViewContainerRef,
                private store: Store<{ user: UserState }>) {
    }

    private showOrHide(show: boolean) {
        this.viewContainer.clear();
        this.store.pipe(
            select('user'),
            take(1),
            map((user: UserState) => user.oci)
        ).subscribe((isOciUser: boolean) => {
            return isOciUser && show
                ? this.viewContainer.createEmbeddedView(this.templateRef)
                : isOciUser && !show
                    ? this.viewContainer.clear()
                    : !isOciUser && show
                        ? this.viewContainer.clear()
                        : this.viewContainer.createEmbeddedView(this.templateRef);

        });
    }
}
